module.exports = __webpack_public_path__ + "static/media/reservation_type_all.f6e7314f.png";